import React, { useState } from 'react';
import { FormProvider } from 'react-hook-form';
import { PageLayout } from '@@viewCommonComponents/forms/Layouts.jsx';
import { Icon, PageTitle, RequiredFieldsNotice } from '@fasstech/middle-design-system';
import FindACompanyForm from './components/FindACompanyForm.jsx';
import useSimulationCompanyForm from './hooks/useSimulationCompanyForm.js';
import { not, propOr } from 'ramda';
import ButtonContainer from '@@viewCommonComponents/forms/ButtonContainer.jsx';
import UnauthorizedModal from '@@viewCommonComponents/UnauthorizedModal.jsx';

const SimulationCompanyForm = ({ company, getMiddleText, departments }) => {
  const [selectedCompany, setSelectedCompany] = useState(
    propOr({}, 'company', company)
  );
  const {
    form,
    isValid,
    onSearch,
    onSearchCcns,
    onSearchOtherCcns,
    companies,
    setCompanies,
    loading,
    ccns,
    loadingCcns,
    otherCcns,
    loadingOtherCcns,
    disableSearch,
    onSubmit,
    noCompaniesFound,
    setCcns,
    noCCN,
    setNoCCN,
    options,
    optionsOtherCcns,
    onSearchCcnOffer,
    ccnOffer,
    loadingCcnOffer,
    setCcnOffer,
    setOtherCcns,
    onSearchFlexiproduct,
    isUnauthorized,
    unauthorizedModalMessage,
    validatedCcn,
    setUnauthorizedModalMessage,
    redirectionInfo,
    validatedCcnIdRef,
    onSelectCcn,
    canGoNext
  } = useSimulationCompanyForm({
    company,
    selectedCompany
  });

  return (
    <FormProvider {...form}>
      <form className={'w-full'} onSubmit={form.handleSubmit(onSubmit)}>
        <PageLayout
          withFormLayout={false}
          className={'flex flex-col items-center w-full gap-6'}
        >
          <Icon name={'circleCompany'} size={100} />
          <PageTitle>{getMiddleText('ENTREPRISE_TITLE_BLOC')}</PageTitle>
          <RequiredFieldsNotice />
          <FindACompanyForm
            getMiddleText={getMiddleText}
            departments={departments}
            onSearch={onSearch}
            onSearchCcns={onSearchCcns}
            companies={companies}
            setCompanies={setCompanies}
            loading={loading}
            disableSearch={disableSearch}
            ccns={ccns}
            loadingCcns={loadingCcns}
            selectedCompany={selectedCompany}
            setSelectedCompany={setSelectedCompany}
            noCompaniesFound={noCompaniesFound}
            setCcns={setCcns}
            noCCN={noCCN}
            setNoCCN={setNoCCN}
            otherCcns={otherCcns}
            loadingOtherCcns={loadingOtherCcns}
            onSearchOtherCcns={onSearchOtherCcns}
            options={options}
            optionsOtherCcns={optionsOtherCcns}
            onSearchCcnOffer={onSearchCcnOffer}
            ccnOffer={ccnOffer}
            loadingCcnOffer={loadingCcnOffer}
            setCcnOffer={setCcnOffer}
            setOtherCcns={setOtherCcns}
            onSearchFlexiproduct={onSearchFlexiproduct}
            validatedCcn={validatedCcn}
            redirectionInfo={redirectionInfo}
            validatedCcnIdRef={validatedCcnIdRef}
            onSelectCcn={onSelectCcn}
            canGoNext={canGoNext}
          />
        </PageLayout>
        <ButtonContainer
          nextButtonLabel={getMiddleText(
            'GENERAL_COMMON_TEXTS_NEXT_BUTTON_LABEL'
          )}
          nextButtonIsDisabled={not(isValid) || !canGoNext || isUnauthorized}
          nextButtonIsLoading={loadingCcnOffer}
          isFormError={not(isValid)}
          getMiddleText={getMiddleText}
          displayResumeButton
          displayPreviousButton={false}
        ></ButtonContainer>
      </form>
      <UnauthorizedModal
        isDisplayed={!!unauthorizedModalMessage}
        unauthorizedModalMessage={unauthorizedModalMessage}
        setUnauthorizedModalMessage={setUnauthorizedModalMessage}
      />
    </FormProvider>
  );
};

export default SimulationCompanyForm;
